module.exports = __webpack_public_path__ + "img/DE01637.67a84e96.png";